import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/clubcard-loyalty.png'


const _withScopeId = n => (_pushScopeId("data-v-7a4327ad"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-bottom-barcode-section" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dummy-background-barcode" }, null, -1))
const _hoisted_3 = { class: "modal-dialog-barcode" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = { class: "modal-header-title" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "สแกนเพื่อรับคอยน์", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header-clubcard" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-body" }, [
  /*#__PURE__*/_createElementVNode("svg", { id: "barCode" }),
  /*#__PURE__*/_createElementVNode("canvas", { id: "qrCode" })
], -1))

export function render(_ctx, _cache) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: _normalizeClass(["modal-bottom-barcode modal-show-bar-qr-code", {show: _ctx.active}]),
      onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.onClickOutside && _ctx.onClickOutside(...args)))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = $event => (_ctx.closeModal()))
              }, [
                _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-xmark" })
              ]),
              _hoisted_7
            ]),
            _hoisted_8
          ]),
          _hoisted_9
        ])
      ])
    ], 2)
  ]))
}